export enum HealthStatus {
  Healthy = 'healthy',
  Uninstalled = 'uninstalled',
  Error = 'error',
  Disabled = 'disabled',
  Dormant = 'dormant',
  mdm = 'mdm',
  Registered = 'registered',
}
export type EndpointsItemsTypes = {
  adminSetState: AdminSetStateNode
  agentUUID: string
  agentVersion: string
  binaryType: string
  city: string
  countryName: string
  cpuFamily: string
  debugLevel: number
  debugMode: boolean
  deviceName: string
  disableOption: boolean
  errorMessage: string
  fallbackMode: boolean
  isTogglePending: boolean
  lastGetConfigTime: string
  osVersion: string
  policyName: string
  realtimeConnection?: boolean
  status: string
  updatedOn: string
  userId: string
  userUUID: string
  isSelected: boolean
}
export type EndpointsLastEvaluatedKeyTypes = {
  agentUUID_userUUID: string
  tenantId: string
  statusNumber: number
  userId?: string
}

export type SearchEndpointsLastEvaluatedKeyTypes = {
  deviceNameLower: {
    deviceNameLower: string
    tenantId: string
    tenantId_agentUUID_userUUID: string
  }
  emailId: {
    emailId: string
    tenantId: string
    tenantId_agentUUID_userUUID: string
  }
  userId: {
    userId: string
    tenantId: string
    tenantId_agentUUID_userUUID: string
  }
}

export type SearchResponseType = {
  tenantId_agentUUID_userUUID: string
  userId?: string
  deviceNameLower?: string
  emailId?: string
  tenantId: string
}

export type EndpointAssociatedUserType = {
  agentUUID: string
}

export type EndpointAssociatedUser = {
  userId: string
  policyName: string
}

export type EndpointMetaDataType = {
  totalInHealthy: number
  totalInDebugMode: number
  totalInFallbackMode: number
  totalInDormant: number
  totalMacOsEP: number
  tenantId_agentUUID_userUUID: string
  totalInDisabled: number
  totalInError: number
  totalInUninstalled: number
  totalLicense: number
  totalWindowsOsEP: number
  totalActiveConnections: number
}

/** Keys whose values are counts (excludes e.g. tenant id string). */
export type EndpointMetaDataCountKey = {
  [K in keyof EndpointMetaDataType]: EndpointMetaDataType[K] extends number
    ? K
    : never
}[keyof EndpointMetaDataType]

export type DiagnosticResultType = {
  [x: string]: {
    error_message: string
    test_status: boolean
  }
}

export interface DiagnosticPayloadType {
  agent: string
}

export type DiagnosticResponseType = {
  message: string
  results: DiagnosticResultType
  download_url: string
  file_timestamp?: string
}

export interface StatusFilterInputRef {
  resetFiler(): void
  selectOnly(option: string): void
}

export interface GetEndpointsRequestType {
  LastEvaluatedKey?:
    | EndpointsLastEvaluatedKeyTypes
    | SearchEndpointsLastEvaluatedKeyTypes
  sortBy?: string
  filterWith?: string
  filterText?: string[]
  sortAscending?: boolean
}

export interface QueryEndpoints {
  pages: EndpointsPages[]
}

export interface EndpointsData {
  Items: EndpointsItemsTypes[]
  LastEvaluatedKey:
    | EndpointsLastEvaluatedKeyTypes
    | SearchEndpointsLastEvaluatedKeyTypes
}

export interface EndpointsPages {
  data: EndpointsData
}

export interface EndpointsListResponse {
  pages: EndpointsPages[]
}

export interface ToggleMultipleEndpointsProps {
  isAllEndpointsSelected: boolean
  selectedEndpoints: EndpointsItemsTypes[]
  filterOptions: EndpointsSearchRequest
}

// Types
export type DownloadDataOptions = {
  filterOptions: EndpointsSearchRequest
  featureName: string
  filteredEndpoints?: EndpointsItemsTypes[]
}

export type PollingRefType = {
  current: NodeJS.Timeout | number | null
}

export interface EndpointsSearchResponse {
  data: EndpointsSearchData
}

export interface EndpointsSearchData {
  endpoints: EndpointItem[]
  pageInfo: EndpointsSearchPageInfo
}

export interface AdminSetStateNode {
  enabled: boolean
  timestamp: string
}

export interface EndpointItem {
  adminSetState: AdminSetStateNode
  agentUUID: string
  userUUID: string
  agentVersion: string
  binaryType: string
  cityName: string
  region: string
  countryName: string
  cpuFamily: string
  debugState: string
  deviceName: string
  disableMode: boolean
  errorMessage: string
  fallbackMode: boolean
  configurationLastUpdated: string
  osVersion: string
  policyName: string
  realtimeConnection: boolean
  status: string
  lastSeen: string
  userId: string
  emailId: string
}

export interface EndpointsSearchPageInfo {
  endCursor: string
  hasNextPage: boolean
}

export interface EndpointsSearchRequest {
  id?: string
  emailId?: string
  deviceName?: string
  userId?: string
  osVersion?: string
  status?: HealthStatus[]
  debugState?: Array<0 | 1 | 2>
  fallbackMode?: boolean
  locationId?: string
  agentVersion?: string
  first?: number
  after?: string
  order?: 'desc' | 'asc'
}

export interface ToggleEndpointParams {
  disableOption?: boolean
  debugMode?: boolean
  agentUUID?: string
  userUUID?: string
}
export interface ToggleEndpointsRequestPayload extends ToggleEndpointParams {
  endpoints?: ToggleEndpointParams[]
}

export interface ToggleEndpointsResponse {
  message: string
}

export interface DiagnosticErrorWithLink {
  error_message: string
  link: string
}

export type DiagnosticErrorsWithLinks = Record<string, DiagnosticErrorWithLink>

export interface BasicEndpointIdentification {
  agentUUID: string
  userUUID: string
}

export interface RemoveDormantEndpointsParams {
  endpoints: BasicEndpointIdentification[]
}

interface RemoveDormantEndpointsSuccessResponse {
  message: string
}

interface RemoveDormantEndpointsFailureResponse {
  errors: {
    details: string
    message: string
  }[]
}

export type RemoveDormantEndpointsResponse =
  | RemoveDormantEndpointsSuccessResponse
  | RemoveDormantEndpointsFailureResponse
